module.exports = __webpack_public_path__ + "static/champions-of-coaching-54dcea8222d10ae93220a25485602bd8.jpg";